import React from "react";
import { useSelector } from "react-redux";
import useGroupItemContext from "../../hooks/useGroupItemContext";

import { Col, Icon, Row } from "antd";
import { CardCustom, Title } from "./styles";
import ButtonStandard from "../../components/utils/button";
import GroupItemForm from "./form";
import GroupItemTable from "./table";

const GroupItemLayout = () => {
  const { translation } = useSelector((state) => state.app);
  const { fetchData, openDrawer } = useGroupItemContext();

  return (
    <CardCustom>
      <Row className="rowHeader" justify="space-between">
        <Col span={8}>
          <Title>{translation.groupItem.title}</Title>
        </Col>
        <Col span={16}>
          <Row type="flex" justify="end" gutter={8}>
            <Col>
              <ButtonStandard buttonType="typeWithoutBackground" onClick={fetchData}>
                <Icon type="reload" />
              </ButtonStandard>
            </Col>
            <Col>
              <ButtonStandard buttonType="addNew" onClick={() => openDrawer()}>
                {translation.groupItem.buttonNew}
              </ButtonStandard>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row type="flex">
        <Col span={24}>
          <GroupItemTable />
        </Col>
      </Row>
    </CardCustom>
  );
};

const GroupItem = () => (
  <>
    <GroupItemLayout />
    <GroupItemForm />
  </>
);

export default GroupItem;
